<template>
  <div class="video-container">
    <div :class="videoContentClass" :style="videoContentStyle">
      <component :is="videoComponent" :attributes="attributes"></component>
    </div>
    <div class="video-caption" v-if="attributes.caption" >
      <p v-markdown="attributes.caption"></p>
    </div>
  </div>
</template>

<script>
import VideoLocal from './VideoLocal.vue'
import VideoIframe from './VideoIframe.vue'
import VideoBrightcove from './VideoBrightcove.vue'

export default {
  props: ['attributes'],
  data () {
    return {
      initHeight: this.$window.innerHeight
    }
  },
  components: {
    VideoLocal,
    VideoIframe,
    VideoBrightcove
  },
  computed: {
    videoContentClass () {
      return {
        'video-content': true,
        [this.videoComponent]: true
      }
    },
    videoComponent () {
      switch (this.attributes.mode) {
        case 'brightcove': return 'VideoBrightcove'
        case 'iframe': return 'VideoIframe'
        default: return 'VideoLocal'
      }
    },
    videoContentStyle () {
      const isImmersive = this.attributes.align && this.attributes.align === 'immersive'
      return {
        height: (isImmersive && this.isTabletWidth) ? this.initHeight + 'px' : 'auto'
      }
    },
    isTabletWidth () {
      return this.$window.innerWidth < 768
    }
  }
}
</script>

<style lang="scss">
.video-content {
  position: relative;
  width: 100%;
  padding: 0;
  line-height: 0;

  & > * {
    width: 100%;
  }

  &.VideoIframe,
  &.VideoBrightcove {
    &::before {
      content: "";
      display: block;
      padding-bottom: 56.25%;
      height: 0;
    }

    & > * {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}

.video-caption {
  p {
    padding: 10px 10px 0 10px;
    margin-bottom: 0;
    color: #666;
    font-family: $font-OpenSans-Regular;
    font-size: 15px;
    line-height: 140%;
  }
}

.immersive {
  padding: 0;

  @include breakpoint($d_medium) {
    padding: 0;
  }

  max-width: none;

  .video-content {
    video {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

</style>
